module.exports = __webpack_public_path__ + "assets/img/road-s.966cba5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/topics/road-s.jpg
// module id = atN/
// module chunks = 0